

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getCompanyAllProject, companyAllProject } from '@/utils/project';

type IProjectInfo = IProject.IResponse.IProjectInfo;

@Component
export default class SelectProject extends Vue {
  @Prop({default: () => []}) private excludeProjectIds!: string[];
  @Prop({default: () => []}) private includeProjectIds!: string[];
  private fetching = false;
  private defaultOption: IProjectInfo[] = [];
  get projectOptions() {
    if (this.includeProjectIds.length > 0) {
      return this.defaultOption.filter((project) => this.includeProjectIds.includes(project.id));
    }
    return this.defaultOption.filter((project) => !this.excludeProjectIds.includes(project.id));
  }
  private created() {
    this.initOptions();
  }
  private initOptions() {
    getCompanyAllProject().then(() => {
      this.defaultOption = companyAllProject;
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  // 处理选项改变
  private handleChange(value: string | string[]) {
    if (Array.isArray(value)) {
      const projectInfos = this.projectOptions.filter((option) => value.includes(option.id));
      this.$emit('changeForMultiple', projectInfos);
      return;
    }
    const projectInfo = this.projectOptions.find((option) => option.id === value) || null;
    this.$emit('change', projectInfo);
  }
}
